var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 0c-4.4112 0-8 3.58885-8 8.00005 0 4.41115 3.5888 7.99995 8 7.99995s8-3.5888 8-7.99995c0-4.4112-3.5888-8.00005-8-8.00005zm0 14.5455c-3.60921 0-6.54545-2.9363-6.54545-6.54545 0-3.60917 2.93624-6.5455 6.54545-6.5455 3.6092 0 6.5455 2.93633 6.5455 6.5455 0 3.60915-2.9363 6.54545-6.5455 6.54545z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.00002 3.39395c-.53459 0-.9695.4352-.9695.97013 0 .53445.43491.96927.9695.96927s.9695-.43482.9695-.96927c0-.53493-.43491-.97013-.9695-.97013z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.99998 6.78787c-.40165 0-.72727.32563-.72727.72728v4.36365c0 .4016.32562.7273.72727.7273s.72727-.3257.72727-.7273v-4.36365c0-.40165-.32562-.72728-.72727-.72728z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2135a7fed68d9437a6820d6c540b80a7.svg";
export { ForwardRef as ReactComponent };